import { FormControl } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiFormLabel-root.MuiInputLabel-root': {
    paddingLeft: 8,
    paddingRight: 8,
    backgroundImage: `linear-gradient(to bottom, transparent 50%, ${theme.palette.background.paper} 50%)`,
    color: theme.palette.text.secondary,
    '&.Mui-disabled': {
      color: theme.palette.text.disabled,
      WebkitTextFillColor: theme.palette.text.disabled,
    },
  },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
    // TODO: no VDS token for this value — needs designer input (#00b5e299 secondary with opacity)
    borderColor: '#00b5e299 !important',
    borderWidth: 2,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: '1px',
    // TODO: no VDS token for this value — needs designer input (rgba(0,0,0,0.23) border)
    borderColor: 'rgba(0, 0, 0, 0.23)',
  },
}));
